module.exports = __webpack_public_path__ + "static/media/oracle-hero.7f2daadb.png";